import { useEffect } from 'react';

/**
 * Temporarily remove main content from accessibility tree which the modal is rendered.
 * If this modal is a child of the main element, this will no-op.
 * @param {*} ref
 */
export default function useHideMain(ref) {
    useEffect(() => {
        const main = document.getElementById('main');
        if (!main || main.contains(ref.current)) return;
        main.setAttribute('aria-hidden', 'true');

        return () => {
            main.setAttribute('aria-hidden', 'false');
        };
    });
}
